import { render, staticRenderFns } from "./CaseStudies.vue?vue&type=template&id=4a5228be&scoped=true&"
import script from "./CaseStudies.vue?vue&type=script&lang=js&"
export * from "./CaseStudies.vue?vue&type=script&lang=js&"
import style0 from "./CaseStudies.vue?vue&type=style&index=0&id=4a5228be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5228be",
  null
  
)

export default component.exports